import React from 'react'


const Linkedin = (props: React.SVGProps<SVGSVGElement>) => (

<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg"
{...props}>
<path d="M17.8097 0.457031H2.09579C1.34305 0.457031 0.734375 1.09092 0.734375 1.87463V18.7053C0.734375 19.489 1.34305 20.1268 2.09579 20.1268H17.8097C18.5625 20.1268 19.1747 19.489 19.1747 18.7092V1.87463C19.1747 1.09092 18.5625 0.457031 17.8097 0.457031ZM6.20526 17.2186H3.46802V7.82934H6.20526V17.2186ZM4.83664 6.55004C3.95784 6.55004 3.24832 5.79321 3.24832 4.85967C3.24832 3.92612 3.95784 3.1693 4.83664 3.1693C5.71183 3.1693 6.42135 3.92612 6.42135 4.85967C6.42135 5.78937 5.71183 6.55004 4.83664 6.55004ZM16.4483 17.2186H13.7147V12.6546C13.7147 11.5674 13.6967 10.1651 12.292 10.1651C10.8694 10.1651 10.6533 11.3522 10.6533 12.5777V17.2186H7.92324V7.82934H10.5452V9.11248H10.5812C10.945 8.37486 11.8382 7.59499 13.1672 7.59499C15.9369 7.59499 16.4483 9.53891 16.4483 12.0668V17.2186Z" 

fill="currentColor"/>
</svg>

)
export default Linkedin